
import React from 'react'
import styles from "./style.module.css";
import Vector164 from "../../../../assets/images/Vector 164.png"
import Connects from "../../../../assets/images/Connects.png"
import Ellipse2 from "../../../../assets/images/Ellipse 2.png"
import Student from "../../../../assets/images/Student.png"
import Workers from "../../../../assets/images/Workers.png"
import Landlord from "../../../../assets/images/Landlord (1).png"
import Enterpur from "../../../../assets/images/Enterpur.png"
import Thinking from "../../../../assets/images/thinking.png"
import Calender from "../../../../assets/images/calender.png"
import Community from "../../../../assets/images/communityPeople.png"
import MobileLine from "../../../../assets/images/MobileLine.png"
import TabletLine from "../../../../assets/images/TabletLine.png"
import { images } from '../../../../assets/images';

const ConnectCard2 = () => {
    const {logo} = images
  return (
     <div className={styles.main}>
        <img className={styles.img1} src={Vector164} alt="" />
        <div className={styles.content}>
            <div id={styles.First} className={styles.firstbox}>
                <div className={styles.box}>
                    <div className={styles.top}>
                    <img src={Landlord} alt="" />
                    </div>
                    <div className={styles.bottom}>
                    <h4>Landlord</h4>
                    </div>
                </div>
                <div className={styles.box}>
                <div className={styles.top}>
                <img src={Enterpur} alt="" />
                    </div>
                    <div className={styles.bottom}>
                    <h4>Entrepreneurs</h4>
                    </div>
                </div>
            </div>
            <div className={styles.secondbox}>
                <div className={styles.eclipse}>
                <h2>One spot to <br /> easily <span>connect</span></h2>
                <img src={logo} alt="" />
                </div>
                
                <img className={styles.img2}  src={Ellipse2} alt="" />
                <img id={styles.MobileLine} src={MobileLine} alt="" />
                <img id={styles.TabletLine} src={TabletLine} alt="" />

                <img className={styles.connectingLines} src={Connects} alt="" />
            </div>
            <div id={styles.Second} className={styles.firstbox}>
                <div className={styles.box}>
                <div className={styles.top}>
                <img src={Student} alt="" />
                    </div>
                    <div className={styles.bottom}>
                    <h4>Students</h4>
                    </div>
                
                    
                </div>
                <div className={styles.box}>
                <div className={styles.top}>
                    <img src={Workers} alt="" />
                    </div>
                    <div className={styles.bottom}>
                    <h4>Working Professionals</h4>
                    </div>
                
                   
                </div>
            </div>
        </div>

        <div className={styles.newBar}>
            <div className={styles.singleBar}>
                <div className={styles.lftPart}>
                    <img src={Community} alt="" />
                </div>
                <div className={styles.rgtPart}>
                    <h3>10000 +</h3>
                    <h5>Communities Members</h5>
                </div>
            </div>
            <div className={styles.singleBar}>
                <div className={styles.lftPart}>
                    <img src={Calender} alt="" />
                </div>
                <div className={styles.rgtPart}>
                    <h3>500 +</h3>
                    <h5>Events organized</h5>
                </div>
            </div>
            <div className={styles.singleBar}>
                <div className={styles.lftPart}>
                    <img src={Thinking} alt="" />
                </div>
                <div className={styles.rgtPart}>
                    <h3>5000 +</h3>
                    <h5>Queries resolved</h5>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ConnectCard2